import ApiCommerce from '@/core/apis/ApiCommerce';
import { IResposta } from '@/core/models/IResposta';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IRepostaConsulta } from '@/core/models/IRepostaConsulta';
import { IProdutoParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/IProdutoParametrosConsulta';
import { IDTOProduto } from '@/models/DTO/IDTOProduto';
import { IProduto } from '@/models/Entidades/IProduto';
import { IParametrosBuscaRapida } from '@/core/models/Consulta/IParametrosBuscaRapida';
import { IItemBuscaRapida } from '@/core/models/Consulta/IItemBuscaRapida';
import { IDTOBuscaProdutoOtimizada } from '@/models/DTO/IDTOBuscaProdutoOtimizada';
import { IProdutoBuscaOtimizadaParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/IProdutoBuscaOtimizadaParametrosConsulta';
import { IDTOProdutoDefinicaoVenderMultiplos } from '@/models/DTO/IDTOProdutoDefinicaoVenderMultiplos';
/**
 * Serviço de Produtos
 */

class ServicoProduto implements IServicoBase<IProduto> {
  endPoint = 'produtos';

  apiCommerce = new ApiCommerce();

  public async incluir(produto: IProduto): Promise<IResposta> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}`, produto);
    return result.data;
  }

  public async atualizar(produto: IProduto): Promise<IResposta> {
    const result: any = await this.apiCommerce.put(`${this.endPoint}/${produto.codigo}`, produto);
    return result.data;
  }

  public async obter(codigo: number): Promise<IProduto> {
    const result: any = await this.apiCommerce.get(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async obterVenderMultiplosPorDefinicoes(codigosDefinicoes: number[]): Promise<IDTOProdutoDefinicaoVenderMultiplos[]> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}/vender-multiplos`, codigosDefinicoes);
    return result.data;
  }

  public async obterBuscaProdutosOtimizada(objeto: IProdutoBuscaOtimizadaParametrosConsulta): Promise<IDTOBuscaProdutoOtimizada[]> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}/busca/otimizada`, objeto);
    return result.data;
  }

  public async obterProdutos(parametrosConsulta: IProdutoParametrosConsulta): Promise<IRepostaConsulta<IDTOProduto>> {
    let parametrosAdicionais = '';

    if (parametrosConsulta.valorPesquisa !== undefined) {
      parametrosAdicionais += `?ValorPesquisa=${parametrosConsulta.valorPesquisa}`;
    }

    if (parametrosConsulta.status !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `Status=${parametrosConsulta.status}`;
    }

    if (parametrosConsulta.numeroPagina !== undefined && parametrosConsulta.numeroPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `NumeroPagina=${parametrosConsulta.numeroPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosPagina !== undefined && parametrosConsulta.qtdeRegistrosPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosPagina=${parametrosConsulta.qtdeRegistrosPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosTotal !== undefined && parametrosConsulta.qtdeRegistrosTotal > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosTotal=${parametrosConsulta.qtdeRegistrosTotal}`;
    }
    if (parametrosConsulta.ordenacao !== undefined) {
      parametrosConsulta.ordenacao.forEach((item) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Ordenacao=${item}`;
      });
    }
    if (parametrosConsulta.codigos !== undefined) {
      parametrosConsulta.codigos.forEach((codigo) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Codigos=${codigo}`;
      });
    }
    const result: any = await this.apiCommerce.get(`${this.endPoint}${parametrosAdicionais}`);
    return result.data;
  }

  public async buscaRapida(parametrosConsultaRapida: IParametrosBuscaRapida): Promise<IItemBuscaRapida[]> {
    const parametros = this.apiCommerce.obterParametrosBuscaRapida(parametrosConsultaRapida);
    const result: any = await this.apiCommerce.get(`${this.endPoint}/busca-rapida${parametros}`);
    return result.data;
  }

  public async buscaRapidaDefinicao(parametrosConsultaRapida: IParametrosBuscaRapida): Promise<IItemBuscaRapida[]> {
    const parametros = this.apiCommerce.obterParametrosBuscaRapidaPost(parametrosConsultaRapida);
    console.log('vai enviar', parametros);
    const result: any = await this.apiCommerce.post(`${this.endPoint}/busca-rapida/definicoes`, parametros);
    return result.data;
  }

  public async deletar(codigo: number): Promise<IResposta> {
    const result: any = await this.apiCommerce.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async importarProdutos(arquivo: any): Promise<IResposta> {
    const result: any = await this.apiCommerce.upload(`${this.endPoint}/importar`, arquivo);
    return result.data;
  }
}

export default ServicoProduto;
